import React from "react";


import Skeleton from '@mui/material/Skeleton';


const SkeletonLoader = ({ height = 215 }) => (

 

    <Skeleton
      variant="rounded"
      // width={40}
      height={height}
      animation="wave" />

);

export default SkeletonLoader;
